import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { CKEditorModule } from 'ng2-ckeditor';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { HomeComponent } from './home/home.component';
import { SidebarComponent } from './home/sidebar/sidebar.component';
import { NavbarComponent } from './home/navbar/navbar.component';
import { FooterComponent } from './home/footer/footer.component';
import { MaincontentComponent } from './home/maincontent/maincontent.component';
import { EmailapiComponent } from './emailapi/emailapi.component';
import { ErrorInterceptorProvider } from './_services/error.interceptor';
import { AlertifyService } from './_services/alertify.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LiveapiComponent } from './liveapi/liveapi.component';
import { DocumentsapiComponent } from './documentsapi/documentsapi.component';
import { ReviewsapiComponent } from './reviewsapi/reviewsapi.component';
import { MaindashboardComponent } from './maindashboard/maindashboard.component';
import { EmailprojectComponent } from './emailapi/emailproject/emailproject.component';
import { EmailconfigurationComponent } from './emailapi/emailconfiguration/emailconfiguration.component';
import { AddnewemailComponent } from './emailapi/addnewemail/addnewemail.component';
import { EmailTemplatesComponent } from './emailapi/emailTemplates/emailTemplates.component';
import { EmailTemplateComponent } from './emailapi/emailTemplate/emailTemplate.component';
import { ChartsModule } from 'ng2-charts';
import { PhotosapiComponent } from './photosapi/photosapi.component';
import { SubscriptionComponent } from './common/subscription/subscription.component';
import { PhotoApiSubscriptionsComponent } from './photosapi/photoApiSubscriptions/photoApiSubscriptions.component';
import { DocumentApiSubscriptionsComponent } from './documentsapi/documentApiSubscriptions/documentApiSubscriptions.component';
import { EmailsChartComponent } from './maindashboard/emailsChart/emailsChart.component';
import { EmailsLogsComponent } from './maindashboard/emailsLogs/emailsLogs.component';
import { ReviewsApiSubscriptionsComponent } from './reviewsapi/reviewsApiSubscriptions/reviewsApiSubscriptions.component';
import { EmailPreviewComponent } from './emailapi/emailPreview/emailPreview.component';
import { WidgetHomeComponent } from './widgets/widget-home/widget-home.component';


@NgModule({
   declarations: [
      AppComponent,
      LoginComponent,
      RegisterComponent,
      HomeComponent,
      SidebarComponent,
      NavbarComponent,
      FooterComponent,
      MaincontentComponent,
      EmailapiComponent,
      LiveapiComponent,
      DocumentsapiComponent,
      ReviewsapiComponent,
      MaindashboardComponent,
      EmailprojectComponent,
      EmailconfigurationComponent,
      AddnewemailComponent,
      EmailTemplatesComponent,
      EmailTemplateComponent,
      PhotosapiComponent,
      SubscriptionComponent,
      PhotoApiSubscriptionsComponent,
      DocumentApiSubscriptionsComponent,
      ReviewsApiSubscriptionsComponent,
      EmailsChartComponent,
      EmailsLogsComponent,
      EmailPreviewComponent,
      WidgetHomeComponent
   ],
   imports: [
      BrowserModule,
      FormsModule,
      ReactiveFormsModule,
      AppRoutingModule,
      CKEditorModule,
      HttpClientModule,
      BrowserAnimationsModule,
      ChartsModule,
      PaginationModule.forRoot()
   ],
   providers: [
      ErrorInterceptorProvider,
      AlertifyService
   ],
   bootstrap: [
      AppComponent
   ]
})
export class AppModule { }
